$(document).foundation();

$(document).ready(function() {
	// utils
	initVerticalCenter();
	inlineSVGs('.footer__social img, .interactive-map__hotspots img, .experience__hotspot img');

	// global
	exclusiveUseMobile();
	initDropdownNav();
	initOffCanvas();
	initSliders();
	initForms();
	initSidebar();
	initVideoPopups();
	initToggleInView();
	initMaps();
	initAccordions();
	initEmergencyPopup();
	initPDFLinks();
	initLazyLoading();
	initAnnualPass();
	initNavItems();
	customCookieBar();

	// template specific
	initGallery();
	initInteractiveMap();
	initShop();
	initBasket();
	initCheckout();
	initTickets();
	initExperience();
	weeklySnaps();
	showWeeklySnapInfoContainer();
	hideWeeklySnapInfoContainer();
	initWeeklySnapsGallery();
	initLandingSlider();

});


function initLandingSlider() {
	$('.landing__slider-inner').each(function () {

		$(this).slick({
		  slidesToShow: 1,
		  arrows: true,
		  prevArrow: '<div><img class="slick-prev landing__slider-arrow" src="/assets/img/slider-prev.svg"></div>',
		  nextArrow: '<div><img class="slick-next landing__slider-arrow" src="/assets/img/slider-next.svg"></div>',
		  speed: '1000',
		  responsive: [
			{
			   breakpoint: 640,
			   settings: {
			     dots: false
			   }
			}
		  ]
		});
	  });
}
function exclusiveUseMobile() {
	$('body.exclusive-use .mobile-buy-tickets a img').attr("src", "/assets/img/exclusive-use-tickets-logo.png");
    $('body.exclusive-use .mobile-buy-tickets a img.search-icon').attr("src", "/assets/img/magnifying-glass-white.svg");
}

function initVerticalCenter() {
	$('.vertical-center').each( function () {
		$(this).wrapInner('<div class="vertical-center-table"><div class="vertical-center-row"><div class="vertical-center-cell"></div></div></div>');
	});
}



// https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
function inlineSVGs(selectorString) {
	$(selectorString).each(function(){
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		$.get(imgURL, function(data) {
			// Get the SVG tag, ignore the rest
			var $svg = $(data).find('svg');

			// Add replaced image's ID to the new SVG
			if(typeof imgID !== 'undefined') {
				$svg = $svg.attr('id', imgID);
			}
			// Add replaced image's classes to the new SVG
			if(typeof imgClass !== 'undefined') {
				$svg = $svg.attr('class', imgClass+' replaced-svg');
			}

			// Remove any invalid XML tags as per http://validator.w3.org
			$svg = $svg.removeAttr('xmlns:a');

			// Check if the viewport is set, if the viewport is not set the SVG wont't scale.
			if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
				$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
			}

			// Replace image with new SVG
			$img.replaceWith($svg);
		}, 'xml');
	});
}



function pad(n, width, z) {
	z = z || '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}





function initDropdownNav() {
	/*$('.header__sub-nav').each( function () {
		$(this).css('left', ($(this).parent().outerWidth() - $(this).outerWidth()) / 2 + 'px' );
	});*/

	$('.header__nav > ul > li, .header__shop-nav > ul > li').on('mouseenter', function (e) {
		if ($('html').attr('data-whatintent') === 'mouse') {
			$(this).find('.header__sub-nav').addClass('open');
		}
	});

	$('.header__nav > ul > li, .header__shop-nav > ul > li').on('mouseleave', function (e) {
		if ($('html').attr('data-whatintent') === 'mouse') {
			$(this).find('.header__sub-nav').removeClass('open');
		}
	});

	$('.header__nav > ul > li, .header__shop-nav > ul > li').on('touchstart', function (e) {
		var $dropdown = $(this).find('.header__sub-nav');
		if ( $dropdown.hasClass('open') ) {
			return; // menu has been pressed second time so allow to navigate there
		} else {
			$('.header__sub-nav.open').removeClass('open');
			$dropdown.addClass('open');
			e.preventDefault();
		}
	});
}




function initOffCanvas() {
	// Add in the overview links for accessing landing pages
	$('.off-canvas__top-nav > li').each(function () {
		if ( $(this).find('.off-canvas__inner-nav').length > 0 ) {
			$(this).find('.off-canvas__inner-nav').prepend('<li><a href="' + $(this).find('a').first().attr('href') + '">' + $('.off-canvas__top-nav').data('overview') + '</a></li > ');
		}
	});

	// Toggle the sub items in the primary nav
	$('.off-canvas__top-nav > li > a').on('click', function () {
		if ( $(this).next('ul.off-canvas__inner-nav').length > 0 ) { // only trigger if there are sub pages to show
			if ( $(this).parent().hasClass('open') ) {
				// second click of main item allows clicking directly through
				return true;
			} else {
				// close any other open items
				$('.off-canvas__top-nav > li.open').removeClass('open').find('ul.off-canvas__inner-nav').slideUp();

				// and open the new one
				$(this).parent().addClass('open');
				$(this).next().slideDown();
			}
			return false; // prevent navigating
		}
	});
}




function initSliders() {
	$('.slider__inner').reformSlider({
		arrows: true,
		dots: false,
		fade: true,
		autoplay: true,
		speed: 4000,
		animationSpeed: 600
	});
// 	$('.slider__inner').slick({
// 		arrows: true,
// 		dots: false,
// 		fade: true,
// 		autoplay: true,
// 		autoplaySpeed: 4000,
// 		speed: 600
// 	});

	if ($('.slider__slide--video').length > 0) {
		coverViewport($('.slider__slide--video iframe'), true);
		$(window).on('resize', function () {
			coverViewport($('.slider__slide--video iframe'), true);
		});
	}
	
if ($('.slider__slide--video').length > 0) {
	if ($(window).width() < 1000) {
		
		$('.slider__slide--video iframe').css('max-height', '56vh');
		
		var videoHeight = $('.slider__slide--video iframe').height()	
		//var captionHeight = $('.slider__caption').height()
		//var sliderVideoHeight = (videoHeight + captionHeight);
		
		$('.slider__inner').css('height', videoHeight);
		$('.slider__slide--video iframe').css('top', '0px');
		$('.slider__caption').css('display', 'none');
		
	}
	

}	


$( window ).resize(function() {
	
	if ($('.slider__slide--video').length > 0) {
		
		if ($(window).width() < 1000) {
			
			$('.slider__slide--video iframe').css('max-height', '56vh');
		
			var videoHeight = $('.slider__slide--video iframe').height()	
			var captionHeight = $('.slider__caption').height()
			var sliderVideoHeight = (videoHeight + captionHeight);
			
			$('.slider__inner').css('height', sliderVideoHeight);
			$('.slider__slide--video iframe').css('top', '0px');
			$('.slider__caption').css('position', 'absolute');
		
		}
		
	}
		
});


	

	
if ($(window).width() < 1000) {

		var imageHeight = $('.reform-slide-current img').height();
		var captionHeight = $('.reform-slide-current .slider__caption').height() || 0;
		var sliderHeight = (captionHeight + imageHeight);
		//alert(sliderHeight);

		$('.slider__inner').css('height', sliderHeight);

}


$( window ).resize(function() {
  if ($(window).width() < 1000) {

		var imageHeight = $('.reform-slide-current img').height();
		var captionHeight = $('.reform-slide-current .slider__caption').height() || 0;
		var sliderHeight = (captionHeight + imageHeight);
		//alert(sliderHeight);

		$('.slider__inner').css('height', sliderHeight);

	}
});









	$('.experience__slider').slick({
		arrows: false,
		dots: false,
		fade: true,
		autoplay: false,
		speed: 600
	});

	$('.experience__nav-prev').on('click', function () {
		$('.experience__slider').slick('slickPrev');
	});

	$('.experience__nav-next').on('click', function () {
		$('.experience__slider').slick('slickNext');
	});




	$('.slider-hotel__inner').reformSlider({
	 arrows: true,
	 dots: false,
	 fade: true,
	 autoplay: true,
	 speed: 4000,
	 animationSpeed: 600
	});

	$('.slider--product').each(function (i, el) {
		var $productSlider = $(el);
		var $thumbnailSlider = $productSlider.next('.slider--thumbnail');

		$productSlider.slick({
			infinite: false,
			arrows: true,
			dots: false,
			fade: true,
			autoplay: false,
			speed: 600,
			asNavFor: $thumbnailSlider,
			slidesToShow: 1,
			slidesToScroll: 1
		});

		$thumbnailSlider.slick({
			infinite: false,
		    arrows: false,
		    dots: false,
		    fade: false,
		    autoplay: false,
		    speed: 600,
			asNavFor: $productSlider,
			slidesToShow: 2,
			slidesToScroll: 1,
			focusOnSelect: true
		});
	});
}

/**
 * Scales any element to simulate the CSS background-size: cover property.
 * @param {DOMelement} element The element to scale
 * @param {bool} [scaleToParent] Scale the element to fill the parent instead
 *                               of the whole browser window.
 */
function coverViewport(element, scaleToParent) {
	if (typeof scaleToParent === 'undefined') { scaleToParent = false; }

	var viewportWidth, viewportHeight;
	if (scaleToParent) {
		viewportWidth = $(element).parent().innerWidth();
		viewportHeight = $(element).parent().innerHeight();
	} else {
		viewportWidth = $(window).innerWidth();
		viewportHeight = $(window).innerHeight();
	}

	var $element = $(element);

	var elementWidth = $element.attr('width');
	var elementHeight = $element.attr('height');

	// Aspect ratio = height / width
	var viewportRatio = viewportHeight / viewportWidth;
	var videoRatio = elementHeight / elementWidth;

	//console.log('Viewport: ', viewportRatio, ' Video: ', videoRatio);


	var newWidth = (elementWidth / elementHeight) * viewportHeight
	var newHeight = (elementHeight / elementWidth) * viewportWidth;
	var newTop = 0;

	if (viewportRatio > videoRatio) {
		// set video height to the viewport, and extend the video beyond the viewport width, i.e. portrait viewport
		//console.log('crop left and right');
		$element.css('height', viewportHeight);
		$element.css('width', newWidth);
		$element.css('left', '-' + (newWidth - viewportWidth) / 2 + 'px');
		$element.css('top', '0');
	} else if (viewportRatio < videoRatio) {
		// set video width to the viewport, and extend the video beyond the viewport height, i.e. landscape viewport
		//console.log('crop top and bottom');
		$element.css('width', viewportWidth);
		$element.css('height', newHeight);
		$element.css('left', '0');
		$element.css('top', '-' + (newHeight - viewportHeight) / 2 + 'px');
	} else {
		// set the video width AND height to the viewport size, i.e. viewport is the same ratio as the video
		//console.log('no crop');
		$element.css('height', viewportHeight);
		$element.css('width', viewportWidth);
		$element.css('left', '0');
		$element.css('top', '0');
	}
}




function initForms() {
	$('.validate-this').validate();

	$('.enquiry-form select').selectric();

	// initialise value up/down buttons for numeric inputs
	$('input[type="number"]').each(function (i, el) {
		var $el = $(el);
		var min = parseInt($el.attr('min'));
		var max = parseInt($el.attr('max'));

		$el.siblings('.number-up').on('click', function() {
			var val = parseInt($el.val());

			if (val + 1 <= max) {
				$el.val(val + 1);
			}
		});

		$el.siblings('.number-down').on('click', function () {
		    var val = parseInt($el.val());

		    if (val - 1 >= min) {
		        $el.val(val - 1);
		    }
		});
	});

	// Contact Us page with multiple selectable forms
	$('.contact-us__selector select').selectric();
	$('.contact-us__selector form').on('submit', function () {
		var formToOpen = $('.contact-us__selector select').val();

		if ( $('.contact-us__form:visible').data('form-name') == formToOpen ) {
			// already open so do nothing
			return false;
		}

		if ( $('.contact-us__form:visible').length > 0) {
			$('.contact-us__form').slideUp(function () {
				setTimeout(function () {
					if (formToOpen == "") {
						$('.contact-us__form').first().slideDown();
					} else {
						$('.contact-us__form[data-form-name="' + formToOpen + '"]').slideDown();
					}
				}, 500);
			});
		} else {
			if (formToOpen == "") {
				$('.contact-us__form').first().slideDown();
			} else {
				$('.contact-us__form[data-form-name="' + formToOpen + '"]').slideDown();
			}
		}

		return false;
	});
}




function initSidebar() {
	if ( $('.sidebar').length > 0 ) {
		setPageAnchors();
		setSidebarHeight();
		$(window).on('resize', setSidebarHeight);
	}
}

function setPageAnchors() {
	if ($('.page-anchors ul').length > 0) {
		var smoothScroll = new Foundation.SmoothScroll(
			$('.page-anchors ul'),
			{ offset: Foundation.MediaQuery.atLeast('large') ? 150 : 100 }
		);

		// scroll to item if current page is loaded with hash
		if (window.location.hash.length > 0) {
			$('.page-anchors ul li a[href="' + window.location.hash + '"]').trigger('click.zf.smoothScroll');
		}
	}
}

function setSidebarHeight() {
	if ($('.sidebar__inner').hasClass('sidebar__inner--relative') ) {
		return;
	}

	if ( $('.sidebar__inner').outerHeight() > $('.sidebar').outerHeight() ) {
		$('.sidebar').outerHeight( $('.sidebar__inner').outerHeight() - 130 );
	}
}



function initVideoPopups() {
	var $modal;
	var modal = '<div id="video-modal" class="gallery-modal gallery-modal--video full reveal" data-reveal data-animation-in="fade-in" data-animation-out="fade-out"><button class="gallery-modal__close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><div class="gallery-modal__iframe"><iframe frameborder="0" src="{{iframeSrc}}"></iframe></div></div>';

	// Detect video links and embed them in a popup
	$('a[href*="youtu"], a[href*="vimeo.com"]').not('[href*="youtube.com/channel"]').addClass('is-video').on('click', function () {
		$modal = $( modal.replace('{{iframeSrc}}', generateVideoEmbedUrl($(this).attr('href'))) );

		$('body').append($modal);

		$('#video-modal').foundation();
        $modal.foundation('open');

        $modal.on('closed.zf.reveal', function () {
	        $modal.remove();
        });

		return false;
	});
}


function generateVideoEmbedUrl(videoUrl) {
	if (videoUrl.indexOf('youtube.com/embed') > -1) {
		// already a YouTube embed code, return same link
		return videoUrl;
	} else if (videoUrl.indexOf('youtu') > -1) {
		// must be either a full or shortened YouTube url so parse and create embed link
	    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
	    var match = videoUrl.match(regExp);

	    if (match && match[2].length == 11) {
	        return 'https://www.youtube.com/embed/' + match[2] + '?rel=0&autoplay=1&modestbranding=1';
	    } else {
	        return videoUrl;
	    }
	} else if (videoUrl.indexOf('player.vimeo.com') > -1) {
		// already a Vimeo embed code, return same link
		return videoUrl;
	} else if (videoUrl.indexOf('https://vimeo.com/') > -1) {
		// normal Vimeo link, so generate and embed code
		return 'https://player.vimeo.com/video/' + videoUrl.split('/')[3] + '?autoplay=true&byline=false&portrait=false&title=false';
	}

	// if all else fails, return the original link
	return embedUrl;
}



function initGallery() {
	// Dynamically load the gallery image into a reveal popup
	$('.gallery__item a').on('click', function (e) {
		e.preventDefault();

		var $clickedThumbnail = $(this);
		console.log(this);
		
		// Get all sibling elements - containing text
		var $siblings = $clickedThumbnail.siblings();
		
		// Create modal HTML with the original image and text from siblings
		var modal = '<div id="gallery-modal" class="gallery-modal full reveal" data-reveal>' +
			'<button class="gallery-modal__close" data-close aria-label="Close modal" type="button">' +
			'<span aria-hidden="true">Close</span></button>' +
			'<button class="gallery-modal__prev">Previous</button>' +
			'<button class="gallery-modal__next">Next</button>' +
			'<div class="gallery-modal__content">' +
			'<div class="gallery-modal__image"><img src="' + $clickedThumbnail.attr('href') + '"></div>' +
			'<div class="gallery-modal__text">' + $clickedThumbnail.next().text() + '</div></div>' +
			'<div class="gallery-modal__images">';
		
		$siblings.each(function () {
			// Check if the sibling has an 'a' tag with an image
			var $image = $(this).find('a img');
			if ($image.length) {
				modal += '<div class="gallery-modal__image"><img src="' + $image.data('src') + '"></div>';
			}
		});
		
		modal += '</div></div>';
		
		var $modal = $(modal);

        $('body').append($modal);

        $('#gallery-modal').foundation();
        $modal.foundation('open');

        $modal.on('closed.zf.reveal', function () {
	        $modal.remove();
        });

        $('.gallery-modal__prev').on('click', function () {
	        // Find the previous, visible item
	        var $previousThumbnail = $clickedThumbnail.parent().prev(':visible');
        });


        $('.gallery-modal__next').on('click', function () {
	        $modal.foundation('close');
	        if ( $clickedThumbnail.parent().next(':visible').length > 0 ) { // is the next thumb visible?
		        $clickedThumbnail.parent().next(':visible').find('a').trigger('click');
	        } else if ( $clickedThumbnail.parent().nextUntil(':visible').length > 0 ) { // no, so find the next visible one
		        $clickedThumbnail.parent().nextAll(':visible').first().find('a').trigger('click');
	        }
        });

        $('.gallery-modal__prev').on('click', function () {
	        $modal.foundation('close');
	        if ( $clickedThumbnail.parent().prev(':visible').length > 0 ) { // is the previous thumb visible?
		        $clickedThumbnail.parent().prev(':visible').find('a').trigger('click');
	        } else if ( $clickedThumbnail.parent().prevUntil(':visible').length > 0 ) { // no, so find the next visible one that comes before this
		        $clickedThumbnail.parent().prevAll(':visible').last().find('a').trigger('click');
	        }
        });

        return false;
	});




	// Filter the gallery items
	var $_filterButtons = $('.gallery__filter-buttons button');
	var $_filterItems = $('.gallery__item');

    $_filterButtons.on('click', function() {

	    if ($(this).hasClass('all')) {
			$('.gallery__filter-buttons button.on').removeClass('on');
			$(this).addClass('on');
			$_filterItems.fadeIn();
			refreshMasonry();
		    return;
	    }

	    if ($(this).hasClass('on')) {
		    $(this).removeClass('on');
	    } else {
		    $('.gallery__filter-buttons button.on').removeClass('on');
		    $(this).addClass('on');
	    }

        var currentCats = '';

        // Loop through the "on" buttons and build a class selector string of the active
        $_filterButtons.each(function() {
            if ($(this).hasClass('on')) {
                currentCats += '.' + $(this).data('category') + ', ';
            }
        });
        currentCats = currentCats.substr(0, currentCats.length - 2); // Remove the last comma and space from the string, otherwise jQuery borks

        // No categories selected so show them all
        if (currentCats == '') {
			$_filterItems.fadeIn();
			setTimeout(refreshMasonry, 500);
            return;
        }

        // Hide or show the elements that match the class
        $_filterItems.each(function() {
            if ($(this).is(currentCats)) {
                $(this).fadeIn();
            } else {
                $(this).fadeOut();
            }
		});

		// setTimeout(refreshMasonry, 500);
	});




	// FEB 7TH 2024 - REMOVED MASONRY LAYOUT - LEFT IN IN CASE CLIENT CHANGES MIND

	// // set masonry layout for visible items

	// refreshMasonry();

	// // reset masonry layout once all images have loaded
	// Foundation.onImagesLoaded($('.gallery__grid .gallery__item img'), function () {
	// 	refreshMasonry();
	// });

	// function refreshMasonry() {
	//     $('.gallery__grid').masonry({
	// 		columnWidth: '.gallery__item-sizer',
	// 		itemSelector: '.gallery__item',
	// 		percentPosition: true,
	// 		horizontalOrder: true
	// 	});
	// };





    // Pre-filter the offers
    // Get the url parameters
    var urlParams = {};
    var e,
        a = /\+/g, // Regex for replacing addition symbol with a space
        r = /([^&=]+)=?([^&]*)/g,
        d = function(s) {
            return decodeURIComponent(s.replace(a, ' '));
        },
        q = window.location.search.substring(1);

    while ((e = r.exec(q))) urlParams[d(e[1])] = d(e[2]);

    if (urlParams['category']) {
        $('.gallery__filter-buttons button[data-category="' + urlParams['category'] + '"]').trigger('click');
    }
}



function initToggleInView() {

	if ($('[data-toggle-in-view]').length === 0) {
        // nothing to toggle
        return;
    }

    $(window).on('scroll.toggle-in-view', function(e) {
        var screenBottom = $(window).scrollTop() + window.innerHeight;

        $('[data-toggle-in-view]').each(function(i, el) {
            var elem = $(el);

            if (elem.offset().top + 100 > screenBottom) {
                // element not in view yet
                return;
            }

            // toggle class
            elem.addClass(elem.data('toggle-in-view'));

            // remove attribute
            elem.removeAttr('data-toggle-in-view');
        });

        if ($('[data-toggle-in-view]').length === 0) {
            // all elements visible, remove scroll event handler
            $(window).off('scroll.toggle-in-view');
        }
    });

    if ($('[data-toggle-in-view]').length > 0) {
	    // Trigger the first scroll
        window.scrollTo(0, 1);
    }
}




function initInteractiveMap() {
	$('.interactive-map__hotspots a').on('click', function () {
		$(this).addClass('current');

		var modal = '<div id="interactive-map__modal" class="interactive-map__modal reveal" data-reveal data-animation-in="fade-in" data-animation-out="fade-out"><button class="interactive-map__modal__close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><div class="interactive-map__modal-content">{{modalContent}}</div></div>';

		var $modal = $( modal.replace('{{modalContent}}', $($(this).attr('href')).html()) );

		$('body').append($modal);
		$('#interactive-map__modal').foundation();
		$modal.foundation('open');

		$modal.on('closed.zf.reveal', function () {
	        $modal.remove();
	        $('.interactive-map__hotspots a.current').removeClass('current');
        });

		return false;
	});



	// Filter heading changes to accordion on mobile
	$('.interactive-map__filters h2').on('click', function () {
		if ( window.innerWidth <= 980 ) {
			$('.interactive-map__filters-list').slideToggle();
		}

		$(window).on('resize', function () {
			if ( window.innerWidth > 980 ) {
				$('.interactive-map__filters-list').show();
			}
		});
	});


	// Filter the hotspots
	var $_filterButtons = $('.interactive-map__filters-list button');
	var $_filterItems = $('.interactive-map__hotspots a, .interactive-map__popup');

    $_filterButtons.on('click', function() {

	    if ($(this).hasClass('all')) {
			$('.interactive-map__filters-list button.on').removeClass('on');
		    $(this).addClass('on');
		    $_filterItems.fadeIn();
		    return;
	    }

	    if ($(this).hasClass('on')) {
		    $(this).removeClass('on');
	    } else {
		    $('.interactive-map__filters-list button.on').removeClass('on');
		    $(this).addClass('on');
	    }

        var currentCats = '';

        // Loop through the "on" buttons and build a class selector string of the active
        $_filterButtons.each(function() {
            if ($(this).hasClass('on')) {
                currentCats += '.' + $(this).data('category') + ', ';
            }
        });
        currentCats = currentCats.substr(0, currentCats.length - 2); // Remove the last comma and space from the string, otherwise jQuery borks

        // No categories selected so show them all
        if (currentCats == '') {
            $_filterItems.fadeIn();
            return;
        }

        // Hide or show the elements that match the class
        $_filterItems.each(function() {
            if ($(this).is(currentCats)) {
                $(this).fadeIn();
            } else {
                $(this).fadeOut();
            }
        });
    });
}





function initMaps() {
	$('[data-map]').each(function () {
		var map, centerLat, centerLng, zoom, marker, markerLat, markerLng;

		if (typeof $(this).data('map-center-coords') != 'undefined') {
			centerLat = parseFloat( $(this).data('map-center-coords').split(',')[0] );
			centerLng = parseFloat( $(this).data('map-center-coords').split(',')[1] );
		} else {
			centerLat = 0;
			centerLng = 0;
		}

		zoom = $(this).data('map-zoom') || 8;

		map = new google.maps.Map($(this)[0], {
			center: {lat: centerLat, lng: centerLng},
			zoom: zoom,
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			mapTypeId: 'roadmap',
			clickableIcons: false
			//styles: mapDarkStyle
		});

		if (typeof $(this).data('map-marker-coords') != 'undefined') {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}

			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});

			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
		}

		$(this).siblings('[data-map-marker]').each(function () {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}

			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});

			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
		});
	});
}


var mapDarkStyle = [ { "featureType": "all", "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "lightness": 40 }, { "color": "#0a0f27" } ] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "off" }, { "color": "#0a0f27" }, { "lightness": 16 }         ] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 20 }, { "visibility": "on" } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#000000" }, { "lightness": 17 }, { "weight": 1.2}, { "visibility": "off" } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 20} ] }, { "featureType": "landscape", "elementType": "geometry.fill", "stylers": [ { "color": "#fafafa" } ] }, { "featureType": "landscape", "elementType": "geometry.stroke", "stylers": [ { "visibility": "off"             } ] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [ { "color": "#ebebeb" }, { "visibility": "on" }, { "saturation": "0" }, { "lightness": "0" }, { "gamma": "1.00" } ] }, { "featureType": "landscape.man_made", "elementType": "geometry.stroke", "stylers": [ { "visibility": "off"             } ] }, { "featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [ { "color": "#c0c0c0" }, { "visibility": "on" }, { "gamma": "1" }, { "lightness": "0" }, { "saturation": "0" } ] }, { "featureType": "landscape.natural", "elementType": "geometry.stroke", "stylers": [ { "visibility": "off"             } ] }, { "featureType": "landscape.natural.landcover", "elementType": "geometry.fill", "stylers": [ { "visibility": "off" }, { "color": "#ffffff" } ] }, { "featureType": "landscape.natural.landcover", "elementType": "geometry.stroke", "stylers": [ { "visibility": "off"             } ] }, { "featureType": "landscape.natural.terrain", "elementType": "geometry.fill", "stylers": [ { "visibility": "on" }, { "color": "#ededed" } ] }, { "featureType": "landscape.natural.terrain", "elementType": "geometry.stroke", "stylers": [ { "visibility": "off"             } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#c9c9c9" }, {                 "lightness": 21 } ] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [ { "color": "#cbcbcb" }, { "visibility": "on" } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#86754d"}, { "lightness": "0" }, { "gamma": "1.00" } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#000000" }, { "lightness": 29 }, { "weight": 0.2} ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": "0" } ] }, { "featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [ { "color": "#86754d"} ] }, { "featureType": "road.arterial", "elementType": "geometry.stroke", "stylers": [ {                 "visibility": "off" } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 16 } ] }, { "featureType": "road.local", "elementType": "geometry.fill", "stylers": [ { "color": "#dbdbdb" } ] }, { "featureType": "road.local", "elementType": "geometry.stroke", "stylers": [ { "visibility": "off"             } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#000000" }, {                 "lightness": 19 } ] }, { "featureType": "transit.line", "elementType": "labels.icon", "stylers": [ { "saturation": "0" } ] }, { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#0a61c9" }, {                 "lightness": 17 } ] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [ { "color": "#0a0f27" } ] } ];




function initAccordions() {
	$('.accordion').accordiom({
		showFirstItem: false
	});
}

function initShop() {
	// submit form when sort selection has changed
	$('.shop-category__sort select').on('change', function () {
		$(this).closest('form').submit();
	});

	// set up e-commerce tracking for product actions
	$('.shop-category__item a').on('click', function () {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'productClick',
			'ecommerce': {
				'currencyCode': $(this).data('currency'),
				'click': {
					'products': [
						{
							'name': $(this).data('product'),
							'id': $(this).data('sku'),
							'price': $(this).data('price'),
							'category': $(this).data('category'),
							'variant': $(this).data('variant-sku')
						}
					]
				}
			}
		});
	});

	$('.shop-product__form').on('submit', function () {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'addToCart ',
			'ecommerce': {
				'currencyCode': $(this).data('currency'),
				'add': {
					'products': [
						{
							'name': $(this).data('product'),
							'id': $(this).data('sku'),
							'price': $(this).data('price'),
							'category': $(this).data('category'),
							'variant': $(this).data('variant-sku'),
            				'quantity': $(this).find('input[name="quantity"]').val()
						}
					]
				}
			}
		});
	});

	$('.shop-tickets form').on('submit', function () {
		var selectedTickets = [];

		// get list of inputs with quantities set
		var inputs = $(this).find('input[name*="Quantity"]').filter(function () {
			return this.value;
		});

		// add each selected ticket to the list for tracking
		inputs.each(function (i, el) {
			var itemRow = $(el).closest('tr');

			selectedTickets.push({
				'name': itemRow.data('product'),
				'id': itemRow.data('sku'),
				'price': itemRow.data('price'),
				'category': itemRow.data('category'),
				'variant': itemRow.data('variant-sku'),
				'quantity': $(el).val()
			});
		});

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'addToCart ',
			'ecommerce': {
				'currencyCode': $(this).data('currency'),
				'add': {
					'products': selectedTickets
				}
			}
		});
	});

	$('.shop-basket__items-delete form').on('submit', function () {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'removeFromCart ',
			'ecommerce': {
				'currencyCode': $(this).data('currency'),
				'remove': {
					'products': [
						{
							'name': $(this).data('product'),
							'id': $(this).data('sku'),
							'price': $(this).data('price'),
							'variant': $(this).data('variant-sku'),
							'quantity': $(this).closest('tr').find('input[name="quantity"]').val()
						}
					]
				}
			}
		});
	});
}

function initBasket() {
    $('.shop-basket__items-quantity-up, .shop-tickets__options-quantity-up').on('click', function () {
        var input = $(this).next('input');
        var val = parseInt(input.val());

        if (isNaN(val)) {
			input.val('1').trigger('change');
            return;
        }

        val += 1;

        // test new value against field pattern
        var pattern = input.attr('pattern');
        var regex = new RegExp('^' + pattern + '$');

        if (regex.test(val)) {
            // matches pattern, so change it
            input.val(val).trigger('change');
        }
    });

    $('.shop-basket__items-quantity-down, .shop-tickets__options-quantity-down').on('click', function () {
        var input = $(this).prev('input');
        var val = parseInt(input.val());

        if (isNaN(val)) {
            return;
        }

        val -= 1;

        // test new value against field pattern
        var pattern = input.attr('pattern');
        var regex = new RegExp('^' + pattern + '$');

        if (regex.test(val)) {
            // matches pattern, so change it
            input.val(val).trigger('change');
        }
	});

	$('.shop-basket__items-quantity-field input[name="quantity"]').on('change', function () {
		// submit form to update quantity in basket
		$(this).closest('form').submit();
	});

	$('.shop-basket__items-quantity-field form').on('submit', function () {
		// disable all basket inputs while quantity is being updated
		$('.shop-basket')
			.find('input[type="text"]').attr('readonly', true).end()
			.find('button').attr('disabled', true);
	});
}



function initCheckout() {
	$('.shop-checkout__address-switcher button').on('click', function () {
		$('.shop-checkout__address--shipping').slideDown();
		$(this).parent().slideUp();
		// set hidden field for backend code
		$(this).next().val(false);
	});
}



function initTickets() {
	$('.tickets-date-hidden').each(function (i, el) {
		var ticketsDateHidden = $(el);
		var today = new Date();
		var tomorrow = new Date();
			tomorrow.setDate(today.getDate() + 1);

		if (today.getHours() >= 16) {
			// if it's after 4pm, go to the next date
			today.setDate(today.getDate() + 1);
			tomorrow.setDate(tomorrow.getDate() + 1);
		}

		// remove time from the dates (for comparison with disabled dates)
		today.setHours(0, 0, 0, 0);
		tomorrow.setHours(0, 0, 0, 0);

		var ticketDate = ticketsDateHidden.fdatepicker({
			format: 'yyyy-mm-dd',
			startDate: today
		}).on('changeDate', function (ev) {
			var time = ev.date.getTime();

			if (ticketDate.datesDisabled && ticketDate.datesDisabled.indexOf(time) >= 0) {
				// this date is disabled, try the next one.
				ev.date.setDate(ev.date.getDate() + 1);

				ticketDate.update(ev.date);
				ticketDate.element.trigger({
				    type: 'changeDate',
				    date: ev.date
				});

				return;
			}

			updateDate(ticketsDateHidden, ev.date);
		}).data('datepicker');

		ticketDate.update(tomorrow);
		ticketDate.element.trigger({
		    type: 'changeDate',
		    date: tomorrow
		});

		ticketsDateHidden.prev('.shop-tickets__options-quantity-up').on('click', function () {
			var currentDate = ticketDate.getUTCDate();
			var nextDate = new Date(currentDate);
			nextDate.setDate(currentDate.getDate() + 1);

			if (ticketDate.datesDisabled.indexOf(nextDate.getTime()) >= 0) {
				// next date disabled, so skip a day
				nextDate.setDate(currentDate.getDate() + 2);
			}

			ticketDate.update(nextDate);
			updateDate(ticketsDateHidden, nextDate);
		});

		ticketsDateHidden.next('.shop-tickets__options-quantity-down').on('click', function () {
			var currentDate = ticketDate.getUTCDate();

			if (currentDate.getTime() <= tomorrow.getTime()) {
				// can't go back in time
				return;
			}

			var prevDate = new Date(currentDate);
			prevDate.setDate(currentDate.getDate() - 1);

			if (ticketDate.datesDisabled.indexOf(prevDate.getTime()) >= 0) {
			    // previous date disabled, so skip a day
			    prevDate.setDate(currentDate.getDate() - 2);
			}

			ticketDate.update(prevDate);
			updateDate(ticketsDateHidden, prevDate);
		});
	});
}

function getOrdinalNum(n) {
	return n + (n > 0 ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10] : '');
}

function updateDate(ticketsDateHidden, theDate) {
	var dateParts = ticketsDateHidden.val().split('-');

	if (!dateParts || dateParts.length < 3) {
		return;
	}

	var date = new Date(Date.UTC(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]), 0 ,0, 0, 0));

	var prettyDateString = date.toLocaleDateString('en-GB', { weekday: 'long', timeZone: 'UTC' });
		prettyDateString += ', ' + getOrdinalNum(date.getUTCDate());
		prettyDateString += ' ' + date.toLocaleDateString('en-GB', { month: 'long', timeZone: 'UTC' });
		prettyDateString += ' ' + date.getUTCFullYear();
		ticketsDateHidden.siblings('.tickets-date-visible').val(prettyDateString);
}




function initExperience() {
	if ($('.experience__slide').length > 0) {
		$('.off-canvas-wrapper').append('<div class="experience__slide-border-top"></div><div class="experience__slide-border-right"></div><div class="experience__slide-border-bottom"></div><div class="experience__slide-border-left"></div>');
	}

	$('.experience__hotspot').on('click', function () {
		$('.experience__close').addClass('experience__close--off-canvas-open');
	});

	$('.experience__off-canvas__close').on('click', function () {
		$('.experience__close').removeClass('experience__close--off-canvas-open');
	});
}



function initEmergencyPopup() {
	// Uncomment to enable cookie saving popup state:
	var delay = $('#emergency-popup').data('popup-delay');
	if ( ($('#emergency-popup').length > 0) && (getCookie('emergency-popup') === '') ) {
		if ($('#emergency-popup').length > 0) {
			setTimeout(function () {
			$('#emergency-popup').foundation('open');
			setCookie('emergency-popup', 'seen', 1);
			}, delay*1000);
		}
	}

/*	var delay = $('#emergency-popup').data('popup-delay');
	setTimeout(function () {
		$('#emergency-popup').foundation('open');
	}, delay*1000); */

}


function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

//add accordion functionality for weekly snaps pages.
function weeklySnaps() {
	$('.accordion-level0, .accordion-level1, .accordion-level2').accordiom({
		showFirstItem: false,
		autoClosing: true
	});
}

function showWeeklySnapInfoContainer() {
	$('.weekly-snaps__image-container').on('mouseenter', function() {
		$(this).find('.weekly-snaps__info-container').css("display", "block")
	});
}

function hideWeeklySnapInfoContainer() {
	$('.weekly-snaps__image-container').on('mouseleave', function() {
		$(this).find('.weekly-snaps__info-container').css("display", "none")
	});
}


function initWeeklySnapsGallery() {


	$('.weekly-snaps__carousel').slick({
		slidesToShow: 4,
		arrows: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	// Dynamically load the gallery image into a reveal popup
	$('.weekly-snaps__cta-button').on('click', function (e) {
		e.preventDefault();

		var galleryImageIndex = $(this).data('gallery-index') || 0;

		var $modal = $('<div id="gallery-modal" class="gallery-modal full reveal loading" data-reveal data-animation-in="fade-in" data-animation-out="fade-out"><button class="gallery-modal__close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><div class="gallery-modal__slider"></div></div>');

        $('body').append($modal);

        $modal.find('.gallery-modal__slider').load($(this).parents('.weekly-snaps__carousel').data('gallery-slider'), function () {
	        $modal.removeClass('loading').find('.gallery-modal__slider').slick({
		        arrows: true,
		        fade: true
	        }).slick('slickGoTo', galleryImageIndex, false);
        });

        $('#gallery-modal').foundation();
        $modal.foundation('open');

        $modal.on('closed.zf.reveal', function () {
	        $modal.remove();
        });

	});
}



function initPDFLinks() {
	$('a[href$=".pdf"]').attr('target', '_blank');
}



function initLazyLoading() {
    var lazyImages = Array.from($("[data-style], .lazy > source, .lazy-img"));

    var options = {
        root: null,
        rootMargin: "150px 0px",
        threshold: 0,
      };

    var lazyImageObserver = new IntersectionObserver(callbackObserver, options);


    function presetImgSizeStyles(img) {
        if (
            img.nodeName === "SOURCE" ||
            img.nodeName === "DIV" ||
            img.classList.contains("bg-img") ||
            typeof img.dataset.presets !== "undefined"
          ) {
            return;
          }
      
          img.style.width = "100%";
          img.style.height = "auto";
          img.style.display = "block";
          img.decoding = "async";
      }      
    
    function setImageViewportWidth(img) {
        var windowWidth = window.innerWidth;
        var imgWidth = img.clientWidth;
        var imgViewportWidth = Math.floor((imgWidth / windowWidth) * 100) + "vw";
        img.sizes = imgViewportWidth;
      }

    function handleImgSrcset(img) {
        setImageViewportWidth(img);
        img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        delete img.dataset.srcset;
        delete img.dataset.src;
        lazyImageObserver.unobserve(img);
       
      }

    function handleImgTag(img) {
        img.src = img.dataset.src;
        delete img.dataset.src;
        lazyImageObserver.unobserve(img);
    }  

    function handleBackgroundImg(img) {
        img.style = img.dataset.style; 
        delete img.dataset;
        lazyImageObserver.unobserve(img);
      }

    function handlePictureElement(img) {
        if (img.nextElementSibling.nodeName === "IMG") {
          img.nextElementSibling.src = img.nextElementSibling.dataset.src;
          delete img.nextElementSibling.dataset.src;
        }
        
        img.srcset = img.dataset.srcset;
        delete img.dataset.srcset;
    
        img.parentElement.classList.remove("lazy");
        lazyImageObserver.unobserve(img);
    }  

    function callbackObserver(entries) {
        entries.forEach(function(entry) {
          var img = entry.target;
          
          if (!entry.isIntersecting) return;
    

          if (img.nodeName === "IMG" && typeof img.dataset.srcset !== 'undefined') {
            handleImgSrcset(img);
			return 
          }

          if (img.nodeName === "IMG" && typeof img.dataset.srcset === "undefined") {
            handleImgTag(img); 
			return
          }

          if (img.nodeName === "DIV") {
            handleBackgroundImg(img);
			return
          }

		  if (img.parentElement.nodeName === "PICTURE") {
            handlePictureElement(img);
			return
          }

          lazyImageObserver.unobserve(img);
        });
      }

      lazyImages.forEach(function (img) {
        presetImgSizeStyles(img)
      })
    
      lazyImages.forEach(function (img) {
        lazyImageObserver.observe(img);
      });
}


function initAnnualPass() {
  var dateInputs = $(".date-field");
  var upload = {
    input: $(".file-upload input"),
    label: $(".file-upload label"),
  };
  var createSections = $(".create-section");
  var btns = $(".create-section .accordion-title");

  function handleUpload(element) {
    var input = element.input;
    var label = element.label;

    input.each(function (index) {
      $(this).on("change", function () {
        if ($(this).val() === "") return;
        label.eq(index).hide();
        $(this).parent().css("padding-left", 0);
        $(this).css("width", "100%");
      });
    });
  }

  function handleDOBfields(elements) {
    function addDatepicker(input) {
      var date = input.fdatepicker({
        format: "dd/mm/yyy",
        showOn: "button",
      });
    }

    elements.each(function () {
      var inputs = $(this).find("input");
      addDatepicker(inputs);
    });
  }

  function handleChildForm(sections) {
    sections.each(function () {
      if ($(this).data("age") !== "child") return;
      var divsToRemove = $(this).find("[data-only-for-adults]");
      divsToRemove.remove();
    });
  }

  function handleInActiveFields(btns, sections) {
    function setInActiveFields(sections) {
      sections.each(function () {
        var reqfieldsInputs = $(this).find("input");
        var reqfieldsSelect = $(this).find("select");
        if ($(this).hasClass("is-active")) {
          reqfieldsInputs.prop("required", true);
          reqfieldsSelect.prop("required", true);
        } else {
          reqfieldsInputs.prop("required", false);
          reqfieldsSelect.prop("required", false);
        }
      });
    }
    setInActiveFields(sections);
    btns.on("click", function () {
      setInActiveFields(sections);
    });
  }

  function setDobOptions() {
    var day = $(".day-dob");
    for (i = 1; i < 32; i++) {
      day.append("<option value = " + i + ">" + i + "</option>");
    }
    var month = $(".month-dob");
    for (j = 1; j < 13; j++) {
      month.append("<option value = " + j + ">" + j + "</option>");
    }
    var date = new Date();
    var cYear = date.getFullYear();

    var year = $(".year-dob");
    for (j = 1930; j <= cYear; j++) {
      year.append("<option value = " + j + ">" + j + "</option>");
    }
  }

  handleUpload(upload);
  handleDOBfields(dateInputs);
  handleChildForm(createSections);
  handleInActiveFields(btns, createSections);
  setDobOptions();

//   $('.notice-banner__close').on('click', function () {
// 	$(this).parent().hasClass('notice-banner').addClass('hide')
//   });

}

function customCookieBar() {
	if ( $('.notice-banner').length > 0 ) {
		if ( !Cookies.get('accepted_cookies') ) {
			$('.notice-banner').fadeIn();
		}

		$('.notice-banner__close').on('click', function () {
			Cookies.set('accepted_cookies', 'true', {expires: $('.notice-banner').data('notice-keep-hidden-for-n-days')});
			$('.notice-banner').css('display', 'none')
			$('.header').css('height', '150px');
			$('.breadcrumb').css('padding-top', 'calc(60px - 3rem)');
		});
	}
}
function initNavItems() {
	var findUs = $('[role="menuitem"] a[href="/find-us/"]')
	if (findUs.length === 0) return;
	findUs.hide()
}
